import { useState, useEffect } from 'react';
import useNavParams from './useNavParams';

import type { FC } from 'react';

export interface TabRoute {
  id: number;
  name: string;
  Component: FC;
}

export function useTabNavigation(pages: TabRoute[]) {
  'use memo';
  const [tabIndex, setTabIndex] = useState<number>(0);
  const { params } = useNavParams();

  useEffect(() => {
    if (params?.page) {
      const idx = pages.findIndex(
        ({ name }) =>
          name.toLocaleLowerCase() === params.page.toLocaleLowerCase()
      );
      setTabIndex((currIdx) => (currIdx === idx ? currIdx : idx));
    }
  }, [pages, params?.page]);

  return [tabIndex, setTabIndex] as const;
}
